export const words = {
    technicalSupport:"Built with love by the J2mvc team.",
    index:"Index",
    home:"Home",
    email:{
        label:"Email Address",
        placeholder:"Write Email Address format such as master@j2mvc.com"
    },
    username:{
        label:"Username",
        placeholder:""
    },
    password:{
        label:"Password",
        placeholder:"******"
    },
    identifyCode:{
        label:"Identify Code",
        placeholder:"Write Identify Code please"
    },
    loadingText:{
        login:"Submitting login...",
        submit:"Data being submitted...",
        goIndex:"Jumping Management Interface..."
    },
    keyword:{
        label:'Keyword',
        placeholder:'Search...',
    },
    catName:{
        label:"Category name",
        placeholder:""
    },
    catAlias:{
        label:"Category alias",
        placeholder:""
    },
    catAddress:{
        label:"Category address",
        placeholder:"Consisting of an alphanumeric -."
    },
    title:{
        label:"Title",
        placeholder:"Write title please..."
    },
    linkAddress:{
        label:"Link Address",
        placeholder:"The link address starts with http:// or https://"
    },
    sorter:"Sorter",
    status:"Status",
    on:"On",
    off:"Off",
    chooseImage:"Choose images",
    chooseFile:"Choose files",
    catIcon:"Category image",
    uploadFile:"Upload files",
    uploadImage:"Upload image",
    uploadImages:"Upload images",
    uploadDrag:"Drag 'n' drop some files here, or click to select files",
    uploadSubmit:"Submit upload",
    insertAll:"Insert all",
    insertImage:"Insert image",
    insertSelected:"Insert Selected",
    insert:"Insert",
    removeSelected:"Remove Selected",
    chooseAll:"Choose all",
    sure:"Sure",
    refresh:"Refresh",
    prevPage:"previous page",
    nextPage:"next page",
    modify:"Modify",
    modifyCat:"Modify Category",
    append:"Append",
    appendCat:"Append Category",
    appendChildCat:"Append child category",
    removeCat:"Remove Category",
    messages:"Messages",
    profile:"Profile",
    desc:"sorted descending",
    asc:"sorted ascending",
    account:"My account",
    notify:"Notifications",
    mailbox:"My mail",
    rememberMe:"Remember me",
    close:"Close current page",
    closeAll:"Close all pages",
    signIn:"Sign in",
    logout:"Sign out",
    forgot:"Forgot password?",
    signUpTip:`Don"t have an account? Sign Up`,
    submit:"Submit",
    cancel:"Cancel",
    subscribe:"Subscribe",
    editGroupTip:"Create attachment grouping for easy query.",
    addGroup:"Add Group",
    editGroup:"Edit Group",
    removeGroup:"Remove Group",
    groupName:"Group Name",
    ungrouped:"Ungrouped",
    localUpload:"Local upload",
    remoteFiles:"Remote files",
    fileLinks:"File Links",
    removePictures:"Remote Pictures",
    picturesLinking:"pictures linking",
    moveToGroup:"Move to Group",
    uploadToGroup:"Upload to Groups",
    reset:"Reset",
    clear:"Clear",
    add:"Add",
    mode:"Modi",
    edit:"Edit",
    remove:"Remove",
    removeBatch:"Batch Remove",
    all:"All",
    list:"List",
    whole:"Whole",
    global:"Global",
    create:"Create",
    search:"Search",
    link:"Link",
    scroll:"Roll",
    setting: "Setting",
    manager:"Manager",
    content:"Content",
    area: "Area",
    client:"Client",
    common:"Common",
    ad: "Advert",
    board: "Board",
    module: "Module",
    document:"Document",
    article: "Article",
    cat: "Category",
    chooseCat: "Choose Category",
    table: "Table",
    shopping: "Shopping Mall",
    product: "Product",
    productCat:"Product category",
    attr: "Attribute",
    spec: "Specifications",
    promotion: "Promotion",
    activity: "Activity",
    coupon: "Coupon", 
    freight: "Freight",
    icon: "Icon", 
    trade: "Trade",
    children: "Children",
    order: "Order",
    delivery: "Deliver goods", 
    integral: "Integral",
    solid: "Solid",
    exchange: "Exchange", 
    interact: "Interact",
    comment: "Comment",
    share: "Share", 
    like: "Thumbs up",
    collect: "Collection",
    stat: "Statistics",
    analysis: "Analysis",
    ui: "UI",
    nav: "Navigation",
    navbar: "Navigation bar", 
    layout: "Layout",
    page: "Page", 
    view: "View",
    item: "Item",
    typography: "Typography",
    component:"Component",
    user: "User",
    write: "Write",
    width:"Width",
    height:"Height",
    alert:{
        tips:"Tips",
        warning:"Warning",
        disagree:"Disagree",
        agree:"Agree",
        sure:"Sure",
        cancel:"Cancel"
    },
    fullScreen:"Full Screen",
    fullScreenExit:"Exit Full Screen",
    loadListData:"Loading List Data...",
    removeTips:"You are deleting the file, which affects the content associated with the file!",
    removeAsk:"This operation cannot be restored. Are you sure you want to continue？",
    removingAttch:"Attachments are being deleted...",
    movingAttach:"Moving attachments...",
    saving:"Saving Group...",
    removingItem:"Removing items...",
    uploaded:"Upload completed",
    uploading:"Uploading...",
    uploadingNoEllipsis:"Uploading",
    waitUpload:"Waiting for upload.",
    removeGroupTips:"You are deleting the attachment group, and the current file will be moved to ungrouped!",
    onceMastFile:"Only one file can be selected",
    image:"Image",
    file:"File"
}
